import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'hold-wrapper',
    standalone: true,
    templateUrl: './hold-wrapper.component.html',
    styleUrls: ['./hold-wrapper.component.scss']
})
export class HoldWrapperComponent {
    @Output() onAction = new EventEmitter<any>();
    private timeoutId: ReturnType<typeof setTimeout> | null = null;
    private intervalTime: number = 410;

    private actionTimeout = (): void => {
        if (this.intervalTime > 51) {
            this.intervalTime -= 60;
        }
        this.timeoutId = setTimeout(this.actionTimeout, this.intervalTime);
        this.onAction.emit();
    }
    onPressDown = (event: Event): void => {
        event.preventDefault();
        this.intervalTime = 410;
        this.timeoutId = setTimeout(this.actionTimeout, this.intervalTime);
        this.onAction.emit();
    }

    onPressUp = (event: Event): void => {
        event.preventDefault();
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
}
